define(
    'Eureka.MaxaCreditApplication.MaxaCreditApplication'
    , [
        'Eureka.MaxaCreditApplication.MaxaCreditApplication.View'
    ]
    , function (
        MaxaCreditApplicationView
    ) {
        'use strict';

        return {
            mountToApp: function mountToApp(container) {
                // using the 'Layout' component we add a new child view inside the 'Header' existing view
                // (there will be a DOM element with the HTML attribute data-view="Header.Logo")
                // more documentation of the Extensibility API in
                // https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html


                var PageType = container.getComponent('PageType')

                PageType.registerPageType({
                    name: 'MaxaCreditApplication',
                    routes: ['credit-application'],
                    view: MaxaCreditApplicationView,
                    defaultTemplate: {
                        name: 'eureka_maxacreditapplication_maxacreditapplication.tpl',
                        displayName: 'Credit Application'
                    }
                })


            }
        };
    });
